module.exports = __webpack_public_path__ + "img/google_step_5.039a7871.jpg";